import React from 'react';
import classNames from 'classnames';

import { ReactComponent as CheckIcon } from '~/assets/images/icons/i-check-circle-animate.svg';

import styles from './AnimatedCheckIcon.module.scss';

interface IAnimatedCheckIcon {
  checked: boolean;
  className?: string;
}

const AnimatedCheckIcon: React.FC<IAnimatedCheckIcon> = ({
  checked,
  className,
}) => (
  <div
    className={classNames(
      styles.container,
      checked ? styles.checked : styles.unchecked,
      className,
    )}
  >
    <CheckIcon />
  </div>
);

export default React.memo(AnimatedCheckIcon);
